var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHelpChat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.9878 4.44531H7.01245C5.10332 4.44531 3.55566 5.99297 3.55566 7.9021V28.4453L3.56098 28.5463C3.63817 29.2699 4.53747 29.6095 5.07309 29.0739L9.94766 24.1982L24.9878 24.1984C26.8969 24.1984 28.4446 22.6507 28.4446 20.7416V7.9021C28.4446 5.99297 26.8969 4.44531 24.9878 4.44531ZM7.01245 6.22309H24.9878C25.9151 6.22309 26.6668 6.97481 26.6668 7.9021V20.7416C26.6668 21.6689 25.9151 22.4206 24.9878 22.4206H9.58036L9.46352 22.4283C9.27089 22.4539 9.09073 22.5421 8.95182 22.681L5.33344 26.2986V7.9021C5.33344 6.97481 6.08516 6.22309 7.01245 6.22309Z",
    fill: "#4D4D4D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpChat);
export default __webpack_public_path__ + "static/media/help-chat.16ea1cfc404faf80d0d9267e98798cb4.svg";
export { ForwardRef as ReactComponent };